import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";

const SchoolSchedule = () => {
  const homeMenu = [
    { label: "Admission Notification ", link: "/howtoapply" },
    { label: "Fee Structure", link: "/feestructure" },
    { label: "Prospectus ", link: "/Prospectus" },
    {
      label: "Virtual School Tour ",
      link: "https://iviewd.com/lotus_valley_gurgaon/",
    },
    { label: "School Schedule ", link: "/schoolSchedule" },
    {
      label: "Transport",
      link: "",
      subMenu: [
        { label: "Transport", link: "/transport" },
        { label: "Bus Routes", link: "/busRoute" },
      ],
    },

    { label: "Special Education", link: "/specialEdu" },
    { label: "Bonding With Parents", link: "/bondingwithparents" },
    // { label: "Career Counselling", link: "/careerCounselling" },
    {
      label: "Meal Menu",
      link: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/pdf/School-Menu.pdf",
    },
    { label: "CBSE Results", link: "/CBSEResult" },
    { label: "Transfer Certificate", link: "/tc" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/apply.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="School Schedule"
                breadEnd="School Schedule"
                breadMid="School Schedule"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div class="text">
                <div class="content font-normal">
                  <div class="text-box">
                    <h5>Important Information</h5>
                    <div class="table font-normal">
                      <table
                        border="1"
                        width="100%"
                        cellpadding="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td>Front Desk </td>
                            <td>0124-4936900, 09650544997</td>
                          </tr>
                          <tr>
                            <td>Admission Enquiries</td>
                            <td>
                              {" "}
                              0124-4936900, 09650544997
                              (admissions@lotusvalleygurgaon.com)
                            </td>
                          </tr>
                          <tr>
                            <td>Transport Enquiries </td>
                            <td>
                              9910220942 (transport@lotusvalleygurgaon.com)
                            </td>
                          </tr>
                          <tr>
                            <td>Portal Enquiries </td>
                            <td>0124-4936900</td>
                          </tr>
                          <tr>
                            <td>Accounts </td>
                            <td>
                              0124-4936900: Extension -
                              107/103(accounts@lotusvalleygurgaon.com)
                            </td>
                          </tr>
                          <tr>
                            <td>General Enquiries </td>
                            <td>info@lotusvalleygurgaon.com</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="text-box">
                    <h5>Meet Us Online</h5>
                    <div class="time-table table text-center">
                      <table
                        border="1"
                        width="100%"
                        cellpadding="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td>WEBSITE </td>
                            <td>www.lotusvalleygurgaon.com</td>
                          </tr>
                          <tr>
                            <td>PORTAL </td>
                            <td>www.lviscampuscare.org</td>
                          </tr>
                          <tr>
                            <td>FACEBOOK </td>
                            <td>
                              https://www.facebook.com/lotusvalleyinternationalschoolgurugram
                            </td>
                          </tr>
                          <tr>
                            <td>TWITTER </td>
                            <td>@lvisgurugram</td>
                          </tr>
                          <tr>
                            <td>YOUTUBE </td>
                            <td>lotusvalleyinternationalschoolgurugram</td>
                          </tr>
                          <tr>
                            <td>INSTAGRAM </td>
                            <td>lvisgurugram</td>
                          </tr>
                          <tr>
                            <td>LINKEDIN </td>
                            <td>
                              https://lotusvalleyinternationalschoolgurugram
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="table">
                      <table
                        border="1"
                        width="100%"
                        cellpadding="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td>Director </td>
                            <td>Anita Malhotra </td>
                            <td>Email: principal@lotusvalleygurgaon.com</td>
                          </tr>
                          <tr>
                            <td>Principal </td>
                            <td>Ruchi Joshi </td>
                            <td>Email: vp@lotusvalleygurgaon.com</td>
                          </tr>
                          <tr>
                            <td>Vice Principal </td>
                            {/* <td>Ritu Jawa </td> */}
                            <td>Email: vppm@lotusvalleygurgaon.com</td>
                          </tr>
                          <tr>
                            <td>Vice Principal </td>
                            <td> Monika Jasrotia </td>
                            <td>Email: vpsr@lotusvalleygurgaon.com</td>
                          </tr>
                          <tr>
                            <td>Headmistress (Primary Wing) </td>
                            {/* <td>Ekta Kapoor Anand </td> */}
                            <td>Email: hmpr@lotusvalleygurgaon.com</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="text-box">
                    <h5>School Timings</h5>
                    <div class="time-table table text-center">
                      <table
                        border="1"
                        width="100%"
                        cellpadding="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td>Grades </td>
                            <td>Summer Timings </td>
                            <td>Winter Timings</td>
                          </tr>
                          <tr>
                            <td>FS 1 / FS 2 / FS 3 (Monday - Friday) </td>
                            <td>8:00 a.m. - 12:30 p.m. </td>
                            <td>8:30 a.m. - 12:30 p.m.</td>
                          </tr>
                          <tr>
                            <td>I - XII (Monday - Friday) </td>
                            <td>8:00 a.m. - 2:30 p.m. </td>
                            <td>8:30 a.m. - 2:30 p.m.</td>
                          </tr>
                          <tr>
                            <td>Office </td>
                            <td>8:00 a.m. - 4:00 p.m. </td>
                            <td>8:00 a.m. - 4:00 p.m.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="text-box">
                    <h5>Visiting Hours for Parents/Guardians</h5>
                    <p>
                      To facilitate the smooth functioning of the school and to
                      ensure an appropriate participation of the
                      Parents/Guardians in the learning process of the child,
                      the following visiting hours shall be observed by the
                      school:
                    </p>

                    <div class="table">
                      <table
                        border="1"
                        width="100%"
                        cellpadding="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td>Director </td>
                            <td>
                              8:30 a.m. - 9:30 a.m. & 2:30 p.m. - 3:30 p.m.
                            </td>
                          </tr>
                          <tr>
                            <td>Class Teachers and Subject Teachers </td>
                            <td>
                              On all Open Houses or with prior appointment on
                              working Saturdays
                            </td>
                          </tr>
                          <tr>
                            <td>Office</td>
                            <td>8:00 a.m. - 4:00 p.m.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p>
                      (Note: Any change in schedule shall be notified by the
                      Director)
                    </p>
                    <p>
                      In case of any emergency, Parents/ Guardians will not be
                      permitted to go directly to the respective classrooms to
                      meet the teachers. Parents are requested to contact the
                      front office in this regard.
                    </p>
                  </div>
                  <div className="text-box">
                    <h5>Bell Timings for Session 2025-26 (Fs 1 − Fs 3)</h5>
                    <div class="table">
                      <table
                        border="1"
                        width="100%"
                        cellpadding="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td>PERIOD </td>
                            <td>SUMMER TIMINGS</td>
                            <td> WINTER TIMINGS (1st Dec – 31st Jan)</td>
                          </tr>
                          <tr>
                            <td>ENRICHMENT PERIOD /ASSEMBLY </td>
                            <td>7:55 a.m. - 8:35 a.m. </td>
                            <td>8:25 a.m. - 8:40 a.m.</td>
                          </tr>
                          <tr>
                            <td>1 </td>
                            <td>8:35 a.m. - 9:20 a.m.</td>
                            <td> 8:40 a.m. - 9:20 a.m.</td>
                          </tr>
                          <tr>
                            <td>BREAK</td>
                            <td> 9:20 a.m. - 9:55 a.m.</td>
                            <td> 9:20 a.m. - 9:55 a.m.</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td> 9:55 a.m. - 10:30 a.m.</td>
                            <td> 9:55 a.m. - 10:30 a.m.</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td> 10:30 a.m. - 11:05 a.m. </td>
                            <td>10:30 a.m. - 11:05 a.m.</td>
                          </tr>
                          <tr>
                            <td>4 </td>
                            <td>11:05 a.m. - 11:40 a.m. </td>
                            <td>11:05 a.m. - 11:40 a.m.</td>
                          </tr>
                          <tr>
                            <td>5 </td>
                            <td>11:40 a.m. - 12.20 p.m.</td>
                            <td> 11:40 a.m. - 12.20 p.m.</td>
                          </tr>
                          <tr>
                            <td>DISPERSAL TIME FOR BUS USERS </td>
                            <td>12:30 p.m.</td>
                            <td> 12:30 p.m.</td>
                          </tr>
                          <tr>
                            <td>DISPERSAL TIME FOR WALKERS</td>
                            <td> 12:40 p.m. </td>
                            <td>12:40 p.m.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <h5>Bell Timings for Session 2025-26 (Juniors I-VII)</h5>
                    <div class="table">
                      <table
                        border="1"
                        width="100%"
                        cellpadding="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td>PERIOD </td>
                            <td>SUMMER TIMINGS</td>
                            <td> WINTER TIMINGS (1st Dec – 31st Jan)</td>
                          </tr>
                          <tr>
                            <td>ENRICHMENT PERIOD /ASSEMBLY </td>
                            <td>7:55 a.m. - 8:35 a.m.</td>
                            <td> 8:25 a.m. - 8:40 a.m.</td>
                          </tr>
                          <tr>
                            <td>1</td>
                            <td> 8:35 a.m. - 9:10 a.m. </td>
                            <td>8:40 a.m. - 9:10 a.m.</td>
                          </tr>
                          <tr>
                            <td>FIRST BREAK (JUNIORS/SENIORS) </td>
                            <td>9:10 a.m. - 9:20 a.m. </td>
                            <td>9:10 a.m. - 9:20 a.m.</td>
                          </tr>
                          <tr>
                            <td>2 </td>
                            <td>9:20 a.m. - 9:55 a.m. </td>
                            <td>9:20 a.m. - 9:55 a.m.</td>
                          </tr>
                          <tr>
                            <td>3 </td>
                            <td>9:55 a.m. - 10:30 a.m. </td>
                            <td>9:55 a.m. - 10:30 a.m.</td>
                          </tr>
                          <tr>
                            <td>4 </td>
                            <td>10:30 a.m. - 11:05 a.m.</td>
                            <td> 10:30 a.m. - 11:05 a.m.</td>
                          </tr>
                          <tr>
                            <td>5 </td>
                            <td>11:05 a.m. - 11:40 a.m. </td>
                            <td>11:05 a.m. - 11:40 a.m.</td>
                          </tr>
                          <tr>
                            <td>SECOND BREAK (JUNIORS I-VII)</td>
                            <td> 11:40 a.m. - 12:00 noon </td>
                            <td>11:40 a.m. - 12:00 noon</td>
                          </tr>
                          <tr>
                            <td>6 </td>
                            <td>12:00 noon - 12:35 p.m.</td>
                            <td> 12:00 noon - 12:35 p.m.</td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td> 12:35 p.m. - 1:10 p.m. </td>
                            <td>12:35 p.m. - 1:10 p.m.</td>
                          </tr>
                          <tr>
                            <td>8 </td>
                            <td>1:10 p.m. - 1:45 p.m. </td>
                            <td>1:10 p.m. - 1:45 p.m.</td>
                          </tr>
                          <tr>
                            <td>9 </td>
                            <td>1:45 p.m. - 2:20 p.m.</td>
                            <td> 1:45 p.m. - 2:20 p.m.</td>
                          </tr>
                          <tr>
                            <td>REFLECTION TIME </td>
                            <td>2:20 p.m. - 2:30 p.m.</td>
                            <td> 2:20 p.m. - 2:30 p.m.</td>
                          </tr>
                          <tr>
                            <td>DISPERSAL TIME FOR BUS USERS </td>
                            <td>2:30 p.m. </td>
                            <td>2:30 p.m.</td>
                          </tr>
                          <tr>
                            <td>DISPERSAL TIME FOR WALKERS</td>
                            <td> 2:40 p.m. </td>
                            <td>2:40 p.m.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <h5>Bell Timings for Session 2025-26 (Seniors VIII-XII)</h5>
                    <div class="table">
                      <table
                        border="1"
                        width="100%"
                        cellpadding="0"
                        cellspacing="0"
                      >
                        <tbody>
                          <tr>
                            <td>PERIOD </td>
                            <td>SUMMER TIMINGS</td>
                            <td> WINTER TIMINGS (1st Dec – 31st Jan)</td>
                          </tr>
                          <tr>
                            <td>ENRICHMENT PERIOD /ASSEMBLY </td>
                            <td>7:55 a.m. - 8:35 a.m.</td>
                            <td> 8:25 a.m. - 8:40 a.m.</td>
                          </tr>
                          <tr>
                            <td>1 </td>
                            <td>8:35 a.m. - 9:10 a.m. </td>
                            <td>8:40 a.m. - 9:10 a.m.</td>
                          </tr>
                          <tr>
                            <td>FIRST BREAK (JUNIORS/SENIORS) </td>
                            <td>9:10 a.m. - 9:20 a.m. </td>
                            <td>9:10 a.m. - 9:20 a.m.</td>
                          </tr>
                          <tr>
                            <td>2 </td>
                            <td>9:20 a.m. - 9:55 a.m. </td>
                            <td>9:20 a.m. - 9:55 a.m.</td>
                          </tr>
                          <tr>
                            <td>3 </td>
                            <td>9:55 a.m. - 10:30 a.m. </td>
                            <td>9:55 a.m. - 10:30 a.m.</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td> 10:30 a.m. - 11:05 a.m. </td>
                            <td>10:30 a.m. - 11:05 a.m.</td>
                          </tr>
                          <tr>
                            <td>5 </td>
                            <td>11:05 a.m. - 11:40 a.m. </td>
                            <td>11:05 a.m. - 11:40 a.m.</td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td> 11:40 a.m. - 12:15 p.m. </td>
                            <td>11:40 a.m. - 12:15 p.m.</td>
                          </tr>
                          <tr>
                            <td>SECOND BREAK (SENIORS VIII-XII) </td>
                            <td>12:15 p.m. - 12:35 p.m. </td>
                            <td>12:15 p.m. - 12:35 p.m.</td>
                          </tr>
                          <tr>
                            <td>7 </td>
                            <td>12:35 p.m. - 1:10 p.m.</td>
                            <td> 12:35 p.m. - 1:10 p.m.</td>
                          </tr>
                          <tr>
                            <td>8 </td>
                            <td>1:10 p.m. - 1:45 p.m.</td>
                            <td> 1:10 p.m. - 1:45 p.m.</td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td> 1:45 p.m. - 2:20 p.m.</td>
                            <td> 1:45 p.m. - 2:20 p.m.</td>
                          </tr>
                          <tr>
                            <td>REFLECTION TIME </td>
                            <td>2:20 p.m. - 2:30 p.m.</td>
                            <td> 2:20 p.m. - 2:30 p.m.</td>
                          </tr>
                          <tr>
                            <td>DISPERSAL TIME FOR BUS USERS</td>
                            <td> 2:30 p.m. </td>
                            <td>2:30 p.m.</td>
                          </tr>
                          <tr>
                            <td>DISPERSAL TIME FOR WALKERS </td>
                            <td>2:40 p.m. </td>
                            <td>2:40 p.m.</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <p>
                      <small>
                        Reporting time for teachers is 7:30 a.m. in Summers &
                        8:00 a.m. in Winters (1st Dec – 31st Jan)
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SchoolSchedule;
